import React from 'react';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import {
  Typography,
  Input,
  Radio,
  Select,
  InputNumber,
  DatePicker,
  Checkbox,
  TimePicker,
} from 'antd';
import TextEditor from 'react-quill';

const { Text } = Typography;

const renderItem = (
  uiType: any,
  disabled: boolean,
) => {
  switch (uiType.uiType) {
    case 1:
      return (
        <Input disabled={disabled} style={{ maxWidth: 600 }} />
      );
    case 2:
      return <InputNumber disabled={disabled} />;
    case 3:
      return (
        <DatePicker format="MM/DD/YYYY" disabled={disabled} />
      );
    case 4:
      // console.log('list1', uiType.options);
      if (typeof uiType.options === 'object') {
        return (
          <Radio.Group disabled={disabled}>
            {uiType.options.map((i: any, index: number) => (
              <Radio key={`${i.value}${index}`} value={i.value}>
                {i.name}
              </Radio>
            ))}
          </Radio.Group>
        );
      } else {
        return <Text type="danger">database data error</Text>;
      }

    case 5:
      // console.log('list', uiType.options);
      if (typeof uiType.options === 'object') {
        const options = uiType.options.map((i: any, index: number) => {
          return { label: i.name, value: i.value, key: `${i.value}${index}` };
        });
        return (
          <Checkbox.Group
            options={options}
            disabled={disabled}
          />
        );
      } else {
        return <Text type="danger">database data error</Text>;
      }

    case 6:
      console.log('list4', uiType.options);
      if (typeof uiType.options === 'object') {
        return (
          <Select style={{ maxWidth: 600 }} disabled={disabled}>
            {uiType.options.map((i: any, index: number) => (
              <Select.Option key={`${i.value}${index}`} value={i.value}>
                {i.name}
              </Select.Option>
            ))}
          </Select>
        );
      } else {
        return <Text type="danger">database data error</Text>;
      }

    case 7:
      // console.log('list3', uiType.options);
      if (typeof uiType.options === 'object') {
        return (
          <Select
            mode="multiple"
            style={{ maxWidth: 600 }}
            disabled={disabled}
          >
            {uiType.options.map((i: any, index: number) => (
              <Select.Option key={`${i.value}${index}`} value={i.value}>
                {i.name}
              </Select.Option>
            ))}
          </Select>
        );
      } else {
        return <Text type="danger">database data error</Text>;
      }
    case 8:
      return (
        <Input.TextArea
          disabled={disabled}
          rows={3}
          style={{ maxWidth: 600 }}
        />
      );
    case 11:
      return (
        <TimePicker format="h:mm:ss A" disabled={disabled} />
      );
    case 12:
      return (
        <Input.Password
          style={{ maxWidth: 600 }}
          disabled={disabled}
          iconRender={(visible) => visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
        />
      );
    case 13:
      return (
        <TextEditor theme="snow" style={{ minHeight: 100 }} />
      );
    default:
      return <Input style={{ maxWidth: 600 }} />;
  }
};

export default renderItem;
